/*
 * Homepage category tabs (Women / Men / Boys / Girls), modelled on outfitters.com.pk.
 *
 * All categories' sections are on the homepage; each has data-home-category from its "Homepage category" setting.
 * <html data-home-category> holds the selected category, and the CSS in snippets/home-category-init.liquid
 * hides the other categories' sections. That snippet also restores the saved choice before the page is drawn.
 *
 * This script (homepage only):
 * - switches category when a header tab with data-category-btn is clicked, instead of following its link
 * - saves the choice in the home_category cookie (7 days) for the next visit
 * - opens the matching tab in the menu drawer
 * - nudges sliders and the theme's deferred section loader to lay out the newly shown sections
 * - in the theme editor, shows the category of the section being edited
 */
(function () {
  var COOKIE_NAME = 'home_category';
  var COOKIE_DAYS = 7;
  var root = document.documentElement;
  var buttons = document.querySelectorAll('[data-category-btn]');

  function currentCategory() {
    return root.getAttribute('data-home-category');
  }

  function saveCategory(category) {
    var expires = new Date(Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie =
      COOKIE_NAME + '=' + encodeURIComponent(category) + ';expires=' + expires + ';path=/;SameSite=Lax';
  }

  function syncButtons(category) {
    buttons.forEach(function (button) {
      if (button.dataset.categoryBtn === category) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  // The menu drawer's tabs are a Slick slider set up by theme.js
  function syncMenu(category) {
    if (!window.jQuery) return;
    var $headings = window.jQuery('.mobile-menu .top_menu .menu-headings');
    if (!$headings.hasClass('slick-initialized')) return;

    var heading = $headings[0].querySelector('.menu-heading[data-menu-category="' + category + '"]');
    var index = heading ? parseInt(heading.getAttribute('data-slick-index'), 10) : NaN;
    if (!isNaN(index)) $headings.slick('slickGoTo', index);
  }

  /*
   * Preload a hidden category's images so switching to it is instant (on outfitters.com.pk the hidden
   * sections are already downloaded when you click). Hidden images never load on their own: native lazy
   * <img>s are switched to eager, and lazysizes elements (product cards, video posters) are unveiled.
   */
  var warmedSections = new WeakSet();

  function warmCategory(category, sectionLimit) {
    if (!category || category === currentCategory()) return;

    var sections = document.querySelectorAll('[data-home-category="' + category + '"]');
    var limit = Math.min(sectionLimit || sections.length, sections.length);

    for (var i = 0; i < limit; i++) {
      var section = sections[i];
      if (warmedSections.has(section)) continue;
      warmedSections.add(section);

      section.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
        // Safari/iOS doesn't start a deferred lazy image when loading flips to eager, and no longer treats it as
        // lazy either, so it never loaded (blank, collapsed cards). Re-setting the sources starts the load.
        if (img.complete) return;
        var srcset = img.getAttribute('srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        var src = img.getAttribute('src');
        if (src) img.setAttribute('src', src);
      });
      if (window.lazySizes) {
        section.querySelectorAll('.lazyload').forEach(function (element) {
          window.lazySizes.loader.unveil(element);
        });
      }
    }
  }

  function setCategory(category, options) {
    options = options || {};
    if (!category) return;

    if (options.save !== false) saveCategory(category);
    if (category === currentCategory()) return;

    warmCategory(category);

    // Jump (not smooth-scroll) to the top first, so the switch shows the new category's hero straight away
    if (options.scroll !== false && window.scrollY > 0) window.scrollTo({ top: 0, behavior: 'instant' });

    root.setAttribute('data-home-category', category);
    syncButtons(category);
    syncMenu(category);

    // Newly shown sections measured themselves while hidden: let sliders recalculate, and let the theme's
    // deferred loader (background videos) pick up sections that were waiting to become visible.
    window.dispatchEvent(new Event('resize'));

    document.dispatchEvent(new CustomEvent('home:category-change', { detail: { category: category } }));
  }

  buttons.forEach(function (button) {
    var category = button.dataset.categoryBtn;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      setCategory(category);
    });

    // Likely next click: load the whole category now
    ['pointerenter', 'touchstart', 'focus'].forEach(function (type) {
      button.addEventListener(
        type,
        function () {
          warmCategory(category);
        },
        { passive: true }
      );
    });
  });

  // Once the page has loaded and the browser is idle, preload the top of every other category
  window.addEventListener('load', function () {
    var idle = window.requestIdleCallback || function (callback) { return setTimeout(callback, 1500); };
    idle(function () {
      buttons.forEach(function (button) {
        warmCategory(button.dataset.categoryBtn, 2);
      });
    });
  });

  syncButtons(currentCategory());

  // Open the drawer on the restored category once theme.js has set up its slider
  if (window.jQuery) {
    var $headings = window.jQuery('.mobile-menu .top_menu .menu-headings');
    if ($headings.hasClass('slick-initialized')) {
      syncMenu(currentCategory());
    } else {
      $headings.one('init', function () {
        setTimeout(function () {
          syncMenu(currentCategory());
        }, 0);
      });
    }
  }

  // Theme editor: selecting or adding a section shows its category, so hidden sections can be edited
  function showSectionCategory(event) {
    var element = event.target.querySelector('[data-home-category]');
    var category = element && element.getAttribute('data-home-category');
    if (category && category !== 'all') setCategory(category, { save: false, scroll: false });
  }
  document.addEventListener('shopify:section:select', showSectionCategory);
  document.addEventListener('shopify:section:load', showSectionCategory);
})();
